import CONSTANTS from '~/constants'

export default ['$http', '$q', ans]

function ans($http, $q) {
  // send up an array of content elements and it returns back the denormalized elements
  this.denormalize = (contentANS) => {
    const deferred = $q.defer()
    const req = {
      method: 'POST',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/ans/denorm`,
      timeout: 100000,
      data: JSON.stringify(contentANS),
    }
    $http(req)
      .then((response) => {
        deferred.resolve(response.data)
      })
      .catch((...args) => {
        deferred.reject(args)
      })
    return deferred.promise
  }

  const referents = ['image', 'gallery', 'video', 'author']
  this.convertToReference = (ansObjects) => {
    return ansObjects.map((itm) => {
      if (referents.indexOf(itm.type) > -1) {
        return {
          type: 'reference',
          referent: {
            provider: 'app.locals.AUTHOR_SERVICE',
            type: itm.type,
            id: itm._id,
            referent_properties: {},
          },
        }
      }
      return itm
    })
  }
}
